export const ENDPOINT =
  process.env.NODE_ENV === 'development' ? '/.netlify/functions' : '/api'
